<div class="content">
  <div class="content-panel">
    <h2>Synthèse des DREV</h2>
    <form [formGroup]="searchForm" #form="ngForm" (ngSubmit)="search()">
      <div class="cols">
        <div class="col">
          <div class="row">
            <!-- Millésime -->
            <div class="col-md-1">
              <div class="mb-3">
                <label translate>Millésime *</label> :
                <input type="text" formControlName="annee" class="form-control" [ngClass]="{'is-invalid': form.submitted && searchForm.get('annee').invalid}" />
              </div>
            </div>
            <!-- Button filtrer -->
            <div class="col-md-2 ml-3 mt-4">
              <button type="submit" class="btn btn-primary" translate>label.rechercher</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <table class="table table-striped" aria-label="Synthèse des DREV" *ngIf="syntheseCahier.length > 0 && syntheseProduit.length > 0; else aucunResultat">
      <thead>
      <tr>
        <th></th>
        <th *ngFor="let column of columns">
          <span translate>{{ column.label }}</span>
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let cahier of syntheseCahier">
        <tr>
          <td>
            <fa-icon *ngIf="!cahier.showDetails" style="font-size:1.3em;"
                     icon="plus" (click)="cahier.showDetails = true" (keydown.enter)="cahier.showDetails = true" class="pointer"></fa-icon>
            <fa-icon *ngIf="cahier.showDetails" style="font-size:1.3em;"
                     icon="minus" (click)="cahier.showDetails = false" (keydown.enter)="cahier.showDetails = false" class="pointer"></fa-icon>
          </td>
          <td *ngFor="let column of columns" class="column-max-width">
            <ng-container [ngSwitch]="column.field">
              <span *ngSwitchCase="'libelle'">{{ cahier.libelleCahier }}</span>
              <span *ngSwitchCase="'nbDR'">{{ cahier.nbDR | number: '1.0-0' }}</span>
              <span *ngSwitchCase="'surface'">{{ cahier.surface | number: '1.4-4' }}</span>
              <span *ngSwitchCase="'volRevendicable'">{{ cahier.volRevendicable | number: '1.2-2' }}</span>
              <span *ngSwitchCase="'vciNouveau'">{{ cahier.vciNouveau | number: '1.2-2' }}</span>
              <span *ngSwitchCase="'nbDREV'">{{ cahier.nbDREV | number: '1.0-0' }}</span>
              <span *ngSwitchCase="'volTotalRevendique'">{{ cahier.volTotalRevendique | number: '1.2-2' }}</span>
              <span *ngSwitchCase="'volRevendiqueCourant'">{{ cahier.volRevendiqueCourant | number: '1.2-2' }}</span>
              <span *ngSwitchCase="'vciRevendiquePasse'">{{ cahier.vciRevendiquePasse | number: '1.2-2' }}</span>
              <span *ngSwitchCase="'vsiReserve'">{{ cahier.vsiReserve | number: '1.2-2' }}</span>
            </ng-container>
          </td>
        </tr>
        <ng-container *ngIf="cahier.showDetails && getProduitsOfCahiers(cahier.idCahier).length > 0">
          <tr *ngFor="let produit of getProduitsOfCahiers(cahier.idCahier)" class="details-row">
            <td></td>
            <td *ngFor="let column of columns" class="column-max-width">
              <ng-container [ngSwitch]="column.field">
                <span *ngSwitchCase="'libelle'">{{ produit.libelleProduit }}</span>
                <span *ngSwitchCase="'nbDR'">{{ produit.nbDR | number: '1.0-0' }}</span>
                <span *ngSwitchCase="'surface'">{{ produit.surface | number: '1.4-4' }}</span>
                <span *ngSwitchCase="'volRevendicable'">{{ produit.volRevendicable | number: '1.2-2' }}</span>
                <span *ngSwitchCase="'vciNouveau'">{{ produit.vciNouveau | number: '1.2-2' }}</span>
                <span *ngSwitchCase="'nbDREV'">{{ produit.nbDREV | number: '1.0-0' }}</span>
                <span *ngSwitchCase="'volTotalRevendique'">{{ produit.volTotalRevendique | number: '1.2-2' }}</span>
                <span *ngSwitchCase="'volRevendiqueCourant'">{{ produit.volRevendiqueCourant | number: '1.2-2' }}</span>
                <span *ngSwitchCase="'vciRevendiquePasse'">{{ produit.vciRevendiquePasse | number: '1.2-2' }}</span>
                <span *ngSwitchCase="'vsiReserve'">{{ produit.vsiReserve | number: '1.2-2' }}</span>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
  </div>
</div>

<!-- Template aucun résultat -->
<ng-template #aucunResultat>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon>Aucun résultat pour le millésime renseigné.
  </div>
</ng-template>
<!-- Fin template aucun résultat -->
